module.exports = __webpack_public_path__ + "static/img/tess_nikina_famille_homoparentale_canada.ff36787.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tess_nikina_famille_homoparentale_canada.jpg
// module id = 37
// module chunks = 1